import { Tooltip } from '@mantine/core';
import { IconInfoCircle, IconSparkles } from '@tabler/icons-react';

export function AIGenerationInfoPanel() {
  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50 px-3 py-2.5 dark:border-blue-700 dark:bg-blue-900/20">
      <div className="flex items-center gap-2">
        <IconSparkles
          size={16}
          className="flex-shrink-0 text-blue-600 dark:text-blue-400"
        />
        <span className="text-sm font-medium text-blue-900 dark:text-blue-100">
          AI is generating draft test actions
        </span>
        <Tooltip
          multiline
          w={320}
          label={
            <div className="space-y-1">
              <div>The generation agent drafts initial actions.</div>
              <div>
                A review agent then refines them—converting static values to dynamic ones—to ensure stable execution.
              </div>
              <div>Final actions may differ from the initial generation.</div>
            </div>
          }
          position="top"
          withArrow
        >
          <div className="flex items-center">
            <IconInfoCircle
              size={16}
              className="cursor-help text-blue-600 dark:text-blue-400"
            />
          </div>
        </Tooltip>
      </div>
    </div>
  );
}
